import { getRecordList } from '@src/utils/media-data';
import OptionalImage from '@src/components/optional-image';
import React, { useMemo } from 'react';
import { observer } from 'mobx-react';
// import useStore from '@src/utils/hooks/use-store';
// import Part4Store from './store';
import Link from '@src/components/link';
import cx from 'classnames';
const styles = require('./index.less');

const Part4 = ({ store }) => {
  store.use();
  const { mainStore } = store;
  const channelList = useMemo(
    () => {
      if (!store?.channelList?.length) return null;
      return (
        <div className={styles.channelList}>
          {getRecordList(store.channelList).map((item, index) => {
            return (
              <Link key={index} className={styles.channelItem} onClick={() => store.onItemClick(item)}>
                <OptionalImage src={item.icon} alt={item.name} className={styles.channelItemIcon} />
              </Link>
            );
          })}
        </div>
      );
    },
    [store?.channelList]
  );
  return (
    <div className={styles.part4Root}>
      <div className={styles.slogan} />
      {mainStore?.game_stage_config !== 'beta_download' && (
        <Link className={cx(styles.orderButton, { [styles.orderButtonActive]: mainStore?.projectConfig?.phone })} onClick={store?.onReservation} />
      )}
      {channelList}
    </div>
  );
};

export default observer(Part4);
